module.exports = __webpack_public_path__ + "img/one-o'clock.f955ab3d.png";